import { render, staticRenderFns } from "./Forensics.vue?vue&type=template&id=2f64d2e5&scoped=true"
import script from "./Forensics.vue?vue&type=script&lang=js"
export * from "./Forensics.vue?vue&type=script&lang=js"
import style0 from "./Forensics.vue?vue&type=style&index=0&id=2f64d2e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64d2e5",
  null
  
)

export default component.exports